import HistoryItemInfoComponent from '@components/history/historyItem/header/historyItemInfoComponent';
import AppContext from '@services/Context';
import { Col, Row } from 'antd';
import React from 'react';

import I18n from '../../../../i18n';
import styled from '../../../../styled-components';

interface Iprop {
    detail: string
    product: string
    distributor: string
    agent: string,
    id: string
}

class HistoryItemHeaderComponent extends React.Component<Iprop, {}> {

    render(): JSX.Element {
        return (
            <AppContext.Consumer>
                {({ locale, theme }) => (
                    <GoEpikHistoryHeader>
                        <Row className="goepik-text-center goepik-side-padding">
                            <Col sm={24} md={24} xl={24}>
                                <Row>
                                    <Col sm={24} md={24} xl={24}>
                                        <h2 className="goepik-history-header-title">{this.props.detail}</h2>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={24} md={24} xl={24}>

                                        <Row type={'flex'} justify={'center'}>
                                            <span className={"evaluation-text"}>{I18n.l('common.evaluation')}:</span>
                                            &nbsp;
                                            <span>{this.props.id}</span>
                                        </Row>

                                        <Row className="goepik-component-padding">
                                            <Col sm={24} md={8} xl={8} >
                                                <HistoryItemInfoComponent
                                                    title={I18n.l('labels.product')}
                                                    content={this.props.product}
                                                />
                                            </Col>
                                            <Col sm={24} md={8} xl={8} >
                                                <HistoryItemInfoComponent
                                                    title={I18n.l('labels.distributor')}
                                                    content={this.props.distributor}
                                                />
                                            </Col>
                                            <Col sm={24} md={8} xl={8} >
                                                <HistoryItemInfoComponent
                                                    title={I18n.l('labels.agent')}
                                                    content={this.props.agent}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </GoEpikHistoryHeader>
                )}
            </AppContext.Consumer>
        );
    }
};

const GoEpikHistoryHeader = styled.div`
    .goepik-history-header-title{
        font-weight:900;
    }
    .evaluation-text{
        font-weight:bold;
    }
    .goepik-side-padding{
        padding-left: 24px!important;
        padding-right: 24px!important;
    }

    .goepik-text-center{
        text-align: center;
    }
`;

export default HistoryItemHeaderComponent;
